'use client';

import type { HeaderAboutUsType } from './data';

import React from 'react';
import Image from 'next/image';

import { Breadcrumb, Container, Flex, Text } from '@/components';
import { useTranslation } from '@/hooks';
import AboutUsHeader from '@/images/aboutUs/about-us.jpg';
import { routes } from '@/statics';

const HeaderAboutUs: HeaderAboutUsType = () => {
  const { t } = useTranslation('pages.aboutUs');

  return (
    <Container>
      <Breadcrumb
        mb={2}
        list={[
          { title: routes.home.title, href: routes.home.url },
          { title: routes.aboutUs.title, href: routes.aboutUs.url },
        ]}
      />
      <Flex
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="100%"
        height={{ base: '138px', md: '405px' }}
        position="relative"
      >
        <Text
          position="absolute"
          top={{ base: 6, md: 10 }}
          left="50%"
          transform="translateX(-50%)"
          color="white"
          fontSize={{ base: 'md', md: '4xl' }}
          fontWeight="bold"
          zIndex={1}
        >
          {t('aboutUs')}
        </Text>
        <Image
          src={AboutUsHeader}
          alt="about-us"
          width={1920}
          height={405}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            filter: 'brightness(0.6)',
            borderRadius: 8,
          }}
          priority
        />
      </Flex>
    </Container>
  );
};

export default HeaderAboutUs;
